export default {};throw new Error(`Could not resolve "lightningcss" imported by "vite".`)